var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarkerOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7714 11.1047L8.94275 13.9333C8.81905 14.0572 8.67215 14.1554 8.51046 14.2224C8.34877 14.2894 8.17545 14.3239 8.00042 14.3239C7.82539 14.3239 7.65207 14.2894 7.49038 14.2224C7.32869 14.1554 7.18179 14.0572 7.05808 13.9333L4.22875 11.1047C3.4829 10.3588 2.97497 9.40847 2.76921 8.37391C2.56344 7.33935 2.66908 6.26701 3.07275 5.29249C3.47643 4.31797 4.16002 3.48503 5.03707 2.89901C5.91413 2.31299 6.94526 2.0002 8.00008 2.0002C9.05491 2.0002 10.086 2.31299 10.9631 2.89901C11.8402 3.48503 12.5237 4.31797 12.9274 5.29249C13.3311 6.26701 13.4367 7.33935 13.231 8.37391C13.0252 9.40847 12.5173 10.3588 11.7714 11.1047Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.33333C10 7.86376 9.78929 8.37247 9.41421 8.74754C9.03914 9.12261 8.53043 9.33333 8 9.33333C7.46957 9.33333 6.96086 9.12261 6.58579 8.74754C6.21071 8.37247 6 7.86376 6 7.33333C6 6.8029 6.21071 6.29419 6.58579 5.91911C6.96086 5.54404 7.46957 5.33333 8 5.33333C8.53043 5.33333 9.03914 5.54404 9.41421 5.91911C9.78929 6.29419 10 6.8029 10 7.33333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerOutline);
export default __webpack_public_path__ + "static/media/LocationMarkerOutline.60f9a963f7a75461f5612e21ad6b994a.svg";
export { ForwardRef as ReactComponent };